import constants from './constants';
import Question from '../question/index';
import { isProductionMode } from '@/constants/global';

const { QUESTION_TYPES } = Question.constants;
const  { QUESTION_TYPES_DATA } = Question.glossary;

const {
  TASK_TYPES,
  TASK_FORMATS,
  TASK_STATUSES,
  TASK_CREATORS,
  TASK_QUESTIONS_TYPES,
  TASK_MEMBER_STATUS,
} = constants;

const TASK_TYPES_DATA = {
  [TASK_TYPES.AUTOMATED_TESTING]: {
    id: TASK_TYPES.AUTOMATED_TESTING,
    name: 'Автоматизированное тестирование',
    questionTypes: [
      QUESTION_TYPES_DATA[QUESTION_TYPES.listSelectionOption],
      QUESTION_TYPES_DATA[QUESTION_TYPES.pairMatchOption],
      QUESTION_TYPES_DATA[QUESTION_TYPES.textInputOption],
    ],
  },
  [TASK_TYPES.EXPERT_REVIEW]: {
    id: TASK_TYPES.EXPERT_REVIEW,
    name: 'Экспертная проверка',
    questionTypes: [
      QUESTION_TYPES_DATA[QUESTION_TYPES.text],
      QUESTION_TYPES_DATA[QUESTION_TYPES.other],
    ],
  },
};

const TASK_QUESTIONS_TYPES_DATA = {
  [TASK_QUESTIONS_TYPES.MANUALLY]: {
    id: TASK_QUESTIONS_TYPES.MANUALLY,
    name: 'Вручную',
  },
  [TASK_QUESTIONS_TYPES.UPLOADING_FILE]: {
    id: TASK_QUESTIONS_TYPES.UPLOADING_FILE,
    name: 'Загружены из файла PDF',
  },
};

const TASK_FORMATS_DATA = {
  [TASK_FORMATS.ONLINE]: {
    id: TASK_FORMATS.ONLINE,
    name: 'Онлайн',
    description: 'Задание выполняется на сайте',
    icon: '$ui-computer',
  },
  [TASK_FORMATS.OFFLINE]: {
    id: TASK_FORMATS.OFFLINE,
    name: 'Оффлайн',
    description: 'Задание выполняется на бумаге',
    icon: '$ui-build',
    tooltip: 'На доработке',
    disabled: isProductionMode,
  },
};

const TASK_STATUSES_DATA = {
  [TASK_STATUSES.DRAFT]: {
    id: TASK_STATUSES.DRAFT,
    name: 'Черновик',
    icon: '$ui-time',
    bgColor: 'ui-bright',
  },
  [TASK_STATUSES.PUBLISHED]: {
    id: TASK_STATUSES.PUBLISHED,
    name: 'Опубликован',
    icon: '$ui-check',
    bgColor: 'ui-success lighten-4',
    color: 'ui-success--text',
  },
  [TASK_STATUSES.DELETED]: {
    id: TASK_STATUSES.DELETED,
    name: 'Снят с публикации',
    icon: '$ui-delete',
    bgColor: 'ui-error lighten-4',
    color: 'ui-error--text',
  },
};

const TASK_CREATORS_DATA = {
  [TASK_CREATORS.HIGH_LEVEL_ORGANIZATION]: {
    id: TASK_CREATORS.HIGH_LEVEL_ORGANIZATION,
    name: 'От вышестоящей организации',
    icon: '$ui-build',
  },
  [TASK_CREATORS.OWNER]: {
    id: TASK_CREATORS.OWNER,
    name: 'Создано вами',
    icon: '$ui-tag',
  },
};

const TASK_MEMBER_STATUS_DATA = {
  [TASK_MEMBER_STATUS.NO_FINISHED]: {
    id: TASK_MEMBER_STATUS.NO_FINISHED,
    text: 'Не выполнено',
    attrs: {
      color: 'ui-neutral',
      get textColor() {
        return `${this.color}--text`;
      },
      get backgroundColor() {
        return `${this.color} lighten-4`;
      },
    },
  },
  [TASK_MEMBER_STATUS.NO_VERIFIED]: {
    id: TASK_MEMBER_STATUS.NO_VERIFIED,
    text: 'На проверке',
    attrs: {
      color: 'ui-warning',
      get textColor() {
        return `${this.color}--text`;
      },
      get backgroundColor() {
        return `${this.color} lighten-4`;
      },
    },
  },
  [TASK_MEMBER_STATUS.COMPLETED]: {
    id: TASK_MEMBER_STATUS.COMPLETED,
    text: 'Выполнено',
    attrs: {
      color: 'ui-success',
      get textColor() {
        return `${this.color}--text`;
      },
      get backgroundColor() {
        return `${this.color} lighten-4`;
      },
    },
  },
};

const TASK_TYPES_LIST = Object.values(TASK_TYPES_DATA);
const TASK_QUESTIONS_TYPES_LIST = Object.values(TASK_QUESTIONS_TYPES_DATA);
const TASK_FORMATS_LIST = Object.values(TASK_FORMATS_DATA)
  .sort((a, b) => b.id - a.id);
const TASK_STATUSES_LIST = Object.values(TASK_STATUSES_DATA);
const TASK_CREATORS_LIST = Object.values(TASK_CREATORS_DATA);

export default {
  TASK_TYPES_DATA,
  TASK_QUESTIONS_TYPES_DATA,
  TASK_FORMATS_DATA,
  TASK_STATUSES_DATA,
  TASK_CREATORS_DATA,
  TASK_MEMBER_STATUS_DATA,

  TASK_TYPES_LIST,
  TASK_QUESTIONS_TYPES_LIST,
  TASK_FORMATS_LIST,
  TASK_STATUSES_LIST,
  TASK_CREATORS_LIST,
};
